import { create } from 'zustand';

interface NotificationFormState {
    showSuccessMessage: boolean;
    confirmMessage: string;
    setShowSuccessMessage: (show: boolean) => void;
    setConfirmMessage: (message: string) => void;
}

export const useNotificationFormStore = create<NotificationFormState>((set) => ({
    showSuccessMessage: false,
    confirmMessage: '',
    setShowSuccessMessage: (show) => set({ showSuccessMessage: show }),
    setConfirmMessage: (message) => set({ confirmMessage: message })
}));
